import gql from 'graphql-tag';
import className from 'classnames/bind';
import { ImageSingularFragment } from '@graphqlTypes';
import { Container, Image, SectionFooter, SectionHeader, RevealWrapper, HeadlineAnim } from '@components';

import styles from './ImageSingular.module.scss';
import { useRef } from 'react';
import { useInView } from 'motion/react';
import { useViewSize } from '@/providers/ViewSizeContext';
import { AnimVals } from '@/utils/animUtils';
const cx = className.bind(styles);

export default function ImageSingular(props: ImageSingularFragment) {
  const { headline, subhead, image, includeFooter, footer } = props;

  // -------------------- Animation

  const rootEl = useRef<HTMLElement | null>(null);
  const { isDesktop } = useViewSize();
  const REVEAL = AnimVals;
  const triggerPercent = isDesktop ? REVEAL.lg.triggerPercent : REVEAL.sm.triggerPercent;
  const isInView = useInView(rootEl, { amount: triggerPercent, once: REVEAL.once });
  const isRevealEnabled = true;

  // -------------------- Render

  return (
    <section className={cx(["image-singular"])} ref={rootEl}>
      <RevealWrapper isInView={isInView}>
        <Container>
          <SectionHeader
            headline={headline}
            subhead={subhead}
            isRevealEnabled={isRevealEnabled}
            isInView={isInView}
          />
          <div className={cx(["image-singular__image"])}>
            <Image image={image} className={cx(["image-singular__image__image"])}/>
          </div>
          { includeFooter && <SectionFooter text={footer.text} ctas={footer.ctas} /> }
        </Container>
      </RevealWrapper>
    </section>
  );

}

ImageSingular.fragments = {
  entry: gql`
    fragment ImageSingular on FlexiblePageContentContentImageSingularLayout {
      headline
      subhead
      image {
        ...ACFMedia
      }
      includeFooter
      footer {
        text
        ctas {
          linkType
          label
          externalLink
          page {
            node {
              uri
            }
          }
        }
      }
    }
  `,
};
